module.exports = __webpack_public_path__ + "static/smallIntro-4e8d0db947ab3abe27ca2dd82b7df1a6.mp4";